const app = angular.module('myba', [
    'ngCookies',
    'angularUtils.directives.dirPagination',
    'ui.router',
    'ct.ui.router.extras',
    'ngAnimate',
    'pwCheck',
    'jlareau.bowser',
    'ngMessages',
    'ngSanitize',
]);